import type { Options as IconOptions } from 'ol/style/Icon'
import { Icon, Style } from 'ol/style'

import vehiclesSpriteSheet from '@/resources/map-markers/devicesAndVehicles.png'

import { genericStyles } from '../../genericStyles'

const vehicleSelectionStylesCache: Map<string, Style> = new Map()

export const getVehicleSelectionFeatureStyle = (
  marker: uui.domain.ui.map.markers.Vehicle,
  mode: uui.domain.ui.map.markers.MapStyles['vehicle']['mode'],
  selected: boolean = false,
) => {
  if (mode === 'off' || !selected) return genericStyles.hidden

  const coordinates = marker.selectionGrid

  const spriteSheetUrl = vehiclesSpriteSheet
  const cellSize = coordinates[2]
  const x = coordinates[0]
  const y = coordinates[1]

  const cacheId = `${x}_${y}`

  if (vehicleSelectionStylesCache.has(cacheId)) {
    const cachedStyle = vehicleSelectionStylesCache.get(cacheId)

    if (cachedStyle) return cachedStyle
  }

  const opts: IconOptions = {
    anchor: [0.5, 0.5],
    anchorOrigin: 'top-left',
    anchorYUnits: 'fraction',
    anchorXUnits: 'fraction',
  }

  const style = new Style({
    image: new Icon({
      src: spriteSheetUrl,
      crossOrigin: 'anonymous',

      scale: 0.5,
      opacity: 1.0,
      rotation: 0.0,
      rotateWithView: true,

      size: [cellSize, cellSize],
      offset: [x, y],

      ...opts,
    }),
  })

  vehicleSelectionStylesCache.set(cacheId, style)

  return style
}
